import NotificationRulesModal from './NotificationRulesModal';

export default NotificationRulesModal;
